import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column align-content-center justify-center text-center grey--text text--darken-1"},[_c(VProgressCircular,{staticClass:"mx-auto mt-12 mb-4",attrs:{"indeterminate":"","color":"primary"}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }